if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"pmc","remotes":[]},
		chunkMatcher: function(chunkId) {return !/^(8(10|775|884)|1343|297|3454|3589|4106|5120|5535)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}